<template>
    <el-card>
        <template #header>
            <div class="card-header">
                <span>公告</span>
            </div>
        </template>
        <el-timeline>
            <el-timeline-item
                v-for="(item, index) in announcements"
                :key="index"
                :timestamp="item.time"
            >
                {{ item.content }}
            </el-timeline-item>
            <el-timeline-item timestamp="2025-05-01">
                <a href="/platform-convention">平台公约</a>
            </el-timeline-item>
        </el-timeline>
    </el-card>
</template>